import { PTCMetadata } from '@api/consumerloans-public-api';
import { getServiceInputMetadata } from '@helpers';

import { useSessionInfo } from '../..';

export const usePTCMetadata = (): PTCMetadata => {
	const sessionInfo = useSessionInfo();

	return getServiceInputMetadata(sessionInfo);
};
